// extracted by mini-css-extract-plugin
export default {"hourSlot":"HourSlot_hourSlot__J4Qik","hourLabel":"HourSlot_hourLabel__W1aLI"};